import { Capability } from 'adc-sirius-module-common';

import { ROUTES } from '../constants';
import { useAppSelector } from '../reducers/hooks';

// Map system-level permissions to their corresponding routes
const capabilityRouteMap = new Map<Capability, string>([
  [Capability.CanGetStudyData, ROUTES.DASHBOARD.ROOT],
  [Capability.CanGetStudies, ROUTES.STUDIES.ROOT],
  [Capability.CanGetOrganizations, ROUTES.ORGANIZATIONS.ROOT],
  [Capability.CanGetUsers, ROUTES.ACCOUNTS.ROOT],
  [Capability.CanGetAssignments, ROUTES.ROLE_ASSIGNMENTS.ROOT],
]);

// Ordered list of permission checks that should be made when
// determining landing page
const prioritizedLandingCapabilities: Capability[] = [
  Capability.CanGetStudyData,
  Capability.CanGetStudies,
  Capability.CanGetOrganizations,
  Capability.CanGetUsers,
  Capability.CanGetAssignments,
];

export const useLandingRoute = (): string | undefined => {
  const capabilities = useAppSelector((state) => state.capabilities);
  const capability = prioritizedLandingCapabilities.find(
    (capability) => capabilities[capability],
  );

  return capability ? capabilityRouteMap.get(capability) : undefined;
};
